import { render, staticRenderFns } from "./photoReview.vue?vue&type=template&id=5ced16d4&scoped=true"
import script from "./photoReview.vue?vue&type=script&lang=js"
export * from "./photoReview.vue?vue&type=script&lang=js"
import style0 from "./photoReview.vue?vue&type=style&index=0&id=5ced16d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ced16d4",
  null
  
)

export default component.exports